<template>
  <!-- 个人主页预览页 -->
  <div class="myDetail">
    <mt-header :title="title">
      <mt-button icon="back" slot="left" @click.native='$router.go(-1)'>返回</mt-button>
    </mt-header>
    <div class="myTitle myWrap">
      <div class="myImg">
        <img :src="httpUrl + userInfoData.photo">
      </div>
      <div class="myInfo">
        <div>
          <span class="myName">{{userInfoDataAccount.name}}</span>
          <icon name='mars' v-if="userInfoData.sex == '0'"></icon>
          <icon name='venus' v-else></icon>
          <span class="myWork">{{userInfoData.position}}</span>
          <span v-if="realNameStatus" class="realname">√实名认证</span>
        </div>
        <div class="lineTwo">
          <p>{{userInfoData.cityName}}</p>
          <p>{{userInfoData.enterTypeName}}</p>
          <p v-if="userInfoData.experienceName != null && userInfoData.experienceName != ''">{{userInfoData.experienceName}}工作经验</p>
          <p v-if="userInfoData.salary != null"><span>{{userInfoData.salary}}</span>元/天</p>
          <div class="myLabels" v-if="positionTypeName != null">
            <span v-for="(positionName,index) in positionTypeName" :key="index">{{positionName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="myWrap myEvaluate">
        <div class="evaluate">
          <div class="stars" v-if="this.evaluateInfo.star==5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==4.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==4">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==3.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==3">
            <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==2.5">
            <icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==2">
            <icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==1.5">
            <icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==1">
            <icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==0.5">
            <icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <div class="stars" v-else-if="this.evaluateInfo.star==0">
            <icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon>
          </div>
          <p>信誉度<span>{{this.evaluateInfo.star}}</span></p>
          <p>成交量<span>{{this.evaluateInfo.turnover}}</span></p>
          <p>评价数<span>{{this.evaluateInfo.exCount}}</span></p>
          <p>完成率<span>{{this.evaluateInfo.Punctuality}}%</span></p>
          <p>完成质量<span>{{this.evaluateInfo.quality}}%</span></p>
          <p>满意度<span>{{this.evaluateInfo.Satisfaction}}%</span></p>
        </div>
        <div class="evaluateLabel">
          <span v-for="(evaluateLabel,index) in evaluateLabel" :key="index">{{evaluateLabel.appraiseLabel}}</span>
        </div>
    </div>
    <div class="myWrap goodSkill">
      <p>擅长技能</p>
      <div class="label">
        <span v-for="(skillName,index) in skillsName" :key="index">{{skillName}}</span>
      </div>
    </div>
    <div class="myWrap myIntroduce">
      <p>我的简介</p>
      <pre>{{userInfoData.aboutMe}}</pre>
    </div>
    <div class="myCase myWrap">
      <p class="title">我的案例</p>
      <div class="caseList" v-for="(workList,index) in workList" :key="index">
        <mt-swipe :auto="4000">
          <mt-swipe-item v-for="(workPhoto,index) in workList.workPhotoList" :key="index">
            <img :src="httpUrl + workPhoto.resAddr" style="width:100%;height:100%;">
          </mt-swipe-item>
        </mt-swipe>
        <div class="caseWrap">
          <h1>{{workList.title}}</h1>
          <p>{{workList.industryName}}</p>
          <p style="line-height:10px;">{{workList.obligation}}</p>
          <pre>{{workList.description}}</pre>
          <a :href="workList.link">{{workList.link}}</a>
        </div>
      </div>
    </div>
    <p class="tips">Copyright @ by Yunzhitu.com - xxx</p>
    <!-- <div class="btns">
      <button>雇佣专家</button>
      <button>发送消息</button>
    </div> -->
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
export default {
  name: 'myDetail',
  data () {
    return {
      title: '',
      star: '4',
      gender: true,
      imgUrl: [require('../assets/img/qqq.jpg'), require('../assets/img/22.jpg'), require('../assets/img/resetPwd/5-1.png'), require('../assets/img/resetPwd/5-2.png')],
      // 当前用户的主页
      accountId: '',
      // 个人信息集合
      userInfoData: '',
      userInfoDataAccount: '',
      realNameStatus:false,
      // 图片服务器地址
      httpUrl: '',
      // 案例信息
      workList: [],
      // 评价数据
      evaluateInfo: '',
      // 评价标签
      evaluateLabel: [],
      // 职位类型
      positionTypeName: [],
      // 擅长技能
      skillsName: []
    }
  },
  mounted () {
    this.accountId = this.$route.query.id
    this.loadTest()
    this.STATE.state.bottomindex='btnFive'
  },
  methods: {
    loadTest: function () {
      let _this = this
      function httpUrl () {
        return _this.axios.get('url/user/imgHttpUrl.json')
      }
      function userInfomationById () {
        return _this.axios.get('url/account/userInfo/getUserInformationById?id=' + _this.accountId)
      }
      function getEvaluateInfoData () {
        return _this.axios.get('url/account/userInfo/vueGetEvaluateInfoData?id=' + _this.accountId)
      }
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      _this.axios.all([httpUrl(), userInfomationById(), getEvaluateInfoData()])
      .then(_this.axios.spread(function (imgurl, userInfo, evaluate) {
        Indicator.close()
        // -----图片服务器地址
        _this.httpUrl = imgurl.data
        // -----基础数据
        _this.userInfoData = userInfo.data
        _this.userInfoDataAccount = userInfo.data.account
        _this.title = userInfo.data.account.name + '的主页'
        // 实名认证
        if(userInfo.data.accountCertificate.status == 1){
          _this.realNameStatus = true
        }
        // 案例反显
        _this.workList = userInfo.data.accountWorks
        // -----评价数据
        _this.evaluateInfo = evaluate.data
        // -----评价标签
        _this.evaluateLabel = evaluate.data.exLabel
        // -----职位类型
        _this.positionTypeName = userInfo.data.positionTypeName.split(',')
        // -----擅长技能
        _this.skillsName = userInfo.data.skills.split('@')
      })).catch(function (response) {
        Indicator.close()
      })
    }
  }
}
</script>

<style scoped>
.myDetail{
  background-color: #f0eff5;
  margin-bottom: 50px;
}
.myWrap{
  margin-bottom:6px;
  background-color: #fff;
}
.myTitle{
  padding: 15px 10px 10px 20px;
  overflow: hidden;
  display: table;
  width: 100%;
  box-sizing: border-box;
}
.myImg{
  display: table-cell;
  width: 70px;
  height: 70px;
  vertical-align: top;
}
.myImg img{
  width: 100%;
  height: 100%;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
}
.myInfo{
  display: table-cell;
  vertical-align: top;
  padding-left: 10px;
  margin-top: 12px;
}
.myInfo .myName{
  font-size: 14px;
  color: #128fe7;
}
.myInfo .fa-icon{
  color: #128fe7;
  transform: scale(0.85);
  vertical-align: middle;
}
.myInfo .myWork{
  font-size: 12px;
  color: #128fe7;
  margin-left: 5px;
}
.myInfo .lineTwo{
  overflow: hidden;
  margin-top: 5px;
}
.myInfo .lineTwo p{
  display: inline-block;
  margin-right: 5px;
  font-size: 12px;
  color: #8a8a8a;
  vertical-align: middle;
}
.myInfo .lineTwo p span{
  font-size: 16px;
  font-weight: bold;
  color: black;
  vertical-align: bottom;
  line-height: 1;
}
.myEvaluate{
  padding: 15px 20px 5px;
}
.myLabels{
  margin-top: 10px;
}
.myLabels span{
  display: inline-block;
  border: 1px solid #128ee9;
  color: #128fe7;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  padding: 0 5px;
  font-size: 12px;
  margin: 0 10px 10px 0;
}
.evaluate{
  margin:5px 0 10px;
}
.evaluate .stars{
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  line-height: 0;
}
.evaluate .stars .fa-icon{
  color: #fd9100;
  transform: scale(0.7);
}
.evaluate p{
  display: inline-block;
  color: #8a8a8a;
  font-size: 12px;
  margin-right: 5px;
  vertical-align: middle;
}
.evaluate p span{
  margin-left: 5px;
  font-size: 16px;
  color: #000;
}
.evaluateLabel span{
  display: inline-block;
  border: 1px solid #fd9100;
  color: #fd9100;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  padding: 0 5px;
  font-size: 12px;
  margin: 0 5px 10px;
}
.label{
  margin-top: 10px;
}
.label span{
  display: inline-block;
  border: 1px solid #d0d3e2;
  color: #646e9f;
  border-radius:13px;
  -webkit-border-radius:13px;
  -moz-border-radius:13px;
  padding: 3px 10px;
  font-size: 12px;
  margin: 0 10px 10px 0;
}
.label span:nth-child(4n+2){
  border: 1px solid #c6efe1;
  color: #3dca99;
}
.label span:nth-child(4n+3){
  border: 1px solid #a49ab5;
  color: #9e5b8a;
}
.label span:nth-child(4n){
  border: 1px solid #fad4d1;
  color: #ed7266;
}
.myIntroduce{
  padding: 15px 20px;
}
.myIntroduce p{
  color: #727272;
  font-size: 12px;
}
.myIntroduce pre{
  font-size: 12px;
}
.myCase .title{
  color: #727272;
  font-size: 12px;
  padding: 15px 20px 0;
}
.caseList{
  margin: 13px 0;
}
.caseWrap{
  padding: 13px 20px;
}
.caseWrap h1{
  font-size: 14px;
}
.caseWrap p{
  font-size: 14px;
  color: #727272;
}
.caseWrap pre{
  margin-top: 10px;
  font-size: 12px;
}
.caseWrap a{
  display: inline-block;
  margin-top: 5px;
  font-size: 12px;
  color: #108fe7;
  text-decoration: none;
  margin-top: 5px;
}
.tips{
  font-size:12px;
  text-align: center;
  color: #808080;
  padding-bottom: 12px;
}
.btns{
  position: fixed;
  left: 0;
  bottom: 48px;
  overflow: hidden;
  width: 100%;
  height: 50px;
}
.btns button{
  width: 50%;
  line-height: 50px;
  float: left;
  border: none;
  outline: none;
  font-size: 14px;
}
.btns button:nth-child(1){
  background-color: #dcecfe;
  color: #0170ff;
}
.btns button:nth-child(2){
  background-color: #108ee9;
  color: #fff;
}
.mint-swipe{
  width: 100%;
  height: 160px;
}
.mint-swipe .mint-swipe-item img{
  width: 100%;
  height: auto;
}
.goodSkill{
  padding: 15px 20px 5px;
}
.goodSkill p{
  color: #727272;
  font-size: 12px;
}

.realname{
  background: #409eff;
  padding: 0 10px;
  border-radius: 11px;
  color: #fff;
  font-size: 10px;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// myDetail.vue?2a4835f0